import { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import intl from "react-intl-universal";
import { TbBuilding, TbLink, TbUser } from "react-icons/tb";

const TypeCard = ({ icon: Icon, title, description, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex flex-col rounded-xl border border-gray-200 bg-white p-5 text-left transition duration-200 hover:-translate-y-0.5 hover:border-[#e7a73f] hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e7a73f]/50 dark:border-brand-dark-border dark:bg-brand-dark-surface dark:hover:border-brand-gold-mid"
  >
    <div className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-500 transition group-hover:border-[#e7a73f]/60 group-hover:text-[#e7a73f] dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-400 dark:group-hover:border-brand-gold-mid dark:group-hover:text-brand-gold-mid">
      <Icon className="h-5 w-5" aria-hidden />
    </div>
    <p className="mt-3 text-base font-semibold text-brand-dark dark:text-gray-100">{title}</p>
    <p className="mt-1 text-sm leading-relaxed text-gray-500 dark:text-gray-400">{description}</p>
  </button>
);

export const BaasEntidadeTypeModal = ({
  open,
  onClose,
  onSelectPersonal,
  onSelectPersonalLink,
  onSelectBusiness,
  showPersonalLinkOption = false,
}) => {
  const [step, setStep] = useState("type");

  useEffect(() => {
    if (!open) {
      setStep("type");
    }
  }, [open]);

  const handleClose = () => {
    setStep("type");
    onClose?.();
  };

  const handlePersonal = () => {
    if (showPersonalLinkOption) {
      setStep("personalMethod");
      return;
    }
    onSelectPersonal?.();
  };

  const isPersonMethod = step === "personalMethod" && showPersonalLinkOption;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-brand-dark dark:text-gray-100">
          {isPersonMethod
            ? intl.get("baas.entidades.create.choosePersonMethod")
            : intl.get("baas.entidades.create.chooseType")}
        </h2>

        {isPersonMethod ? (
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            <TypeCard
              icon={TbUser}
              title={intl.get("baas.entidades.create.typePersonalCreate")}
              description={intl.get("baas.entidades.create.typePersonalCreateDesc")}
              onClick={onSelectPersonal}
            />
            <TypeCard
              icon={TbLink}
              title={intl.get("baas.entidades.create.typePersonalLink")}
              description={intl.get("baas.entidades.create.typePersonalLinkDesc")}
              onClick={onSelectPersonalLink}
            />
          </div>
        ) : (
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            <TypeCard
              icon={TbUser}
              title={intl.get("baas.entidades.create.typePersonal")}
              description={intl.get("baas.entidades.create.typePersonalDesc")}
              onClick={handlePersonal}
            />
            <TypeCard
              icon={TbBuilding}
              title={intl.get("baas.entidades.create.typeBusiness")}
              description={intl.get("baas.entidades.create.typeBusinessDesc")}
              onClick={onSelectBusiness}
            />
          </div>
        )}

        <div className="mt-6 flex justify-end gap-2">
          {isPersonMethod ? (
            <button
              type="button"
              className="extract-filter-panel__btn"
              onClick={() => setStep("type")}
            >
              {intl.get("baas.entidades.create.personMethodBack")}
            </button>
          ) : null}
          <button type="button" className="extract-filter-panel__btn" onClick={handleClose}>
            {intl.get("common.cancel")}
          </button>
        </div>
      </div>
    </Dialog>
  );
};
